import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { PageData } from '.';


export default /*#__PURE__*/_defineComponent({
  __name: 'CPagination',
  props: {
    value: { default: 1 },
    totalCount: null,
    pageCount: { default: 10 },
    btnRangeQty: { default: 2 }
  },
  emits: ["input", "page-change"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: number): void;
    (event: 'page-change', value: PageData): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: number, totalCount: number, pageCount: number, btnRangeQty: number };





const currentPage = computed({
    get: () => props.value,
    set: (value: number) => {
        if (props.value == value || !value || value > totalPages.value) return;

        emit('input', value);
        emit('page-change', {
            page: value,
            from: (value - 1) * props.pageCount
        });
    }
});

const totalPages = computed(() => Math.ceil(props.totalCount / props.pageCount));

const displayedPages = computed(() => {
    const start = Math.max(1, currentPage.value - props.btnRangeQty);
    const end = Math.min(totalPages.value, currentPage.value + props.btnRangeQty);

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
});

const goToPage = (pageNumber: number) => {
    currentPage.value = pageNumber;
};

return { __sfc: true,props, emit, currentPage, totalPages, displayedPages, goToPage }
}

})